<template>
  <div>
    <b-card>
      <b-spinner
        v-if="initialLoader"
        small
        label="Small Spinner"
      />

      <b-alert
        variant="danger"
        :show="errorMessage ? true : false"
        class="mb-0"
      >
        <div class="alert-body">
          <p>
            {{ errorMessage }}
          </p>
        </div>
      </b-alert>

      <div v-if="!initialLoader && !errorMessage">
        <div class="d-flex justify-content-between align-items-center">
          <span v-b-toggle.invoices-list>
            <b-badge
              pill
              :variant="unmatchedInvoices.length > 0 ? 'danger' : 'primary'"
            >
              {{ unmatchedInvoices.length }}
            </b-badge>
            Unmatched Invoice(s) <span class="text-muted"> - Last 60 days</span>
          </span>
          <b-button
            :disabled="refreshLoader"
            variant="text"
            size="sm"
            class="p-0"
            @click.prevent="getData({isRefresh: true})"
          >
            <b-spinner
              v-if="refreshLoader"
              small
              label="Small Spinner"
            />
            <feather-icon
              v-else
              icon="RotateCcwIcon"
              size="16"
            />
          </b-button>
        </div>
        <b-collapse
          id="invoices-list"
          class="mt-2"
        >
          <div class="invoices-list">
            <span
              v-for="(invoice, index) in unmatchedInvoices"
              :key="index"
              class="clickable-invoice mr-1"
              @click="displayPOInvoiceDetailsNo = invoice.id"
            >
              {{ invoice.invoice_no }}<span v-if="index < unmatchedInvoices.length - 1">, </span>
            </span>
          </div>
        </b-collapse>
      </div>
    </b-card>

    <scannned-purchase-order-detail
      v-if="displayPOInvoiceDetailsNo"
      :invoice-id="displayPOInvoiceDetailsNo"
      @modal-closed="displayPOInvoiceDetailsNo = null"
    />

  </div>
</template>

<script>
import {
  BCard, BSpinner, BAlert, BCollapse, VBToggle, BBadge, BButton,
} from 'bootstrap-vue'
import axios from 'axios'
import ScannnedPurchaseOrderDetail from '@/components/Invoices/Invoice/ScannnedPurchaseOrderDetail.vue'

export default {
  directives: {
    'b-toggle': VBToggle,
  },
  components: {
    BCard,
    BSpinner,
    BAlert,
    BCollapse,
    BBadge,
    BButton,
    ScannnedPurchaseOrderDetail,

  },
  props: {
    needRefresh: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      initialLoader: false,
      errorMessage: null,
      unmatchedInvoices: [],
      refreshLoader: false,
      displayPOInvoiceDetailsNo: null,
    }
  },
  watch: {
    needRefresh(newVal) {
      if (newVal) {
        this.getData({ isRefresh: true })
      }
    },
  },
  created() {
    this.getData()
  },
  methods: {
    getData(options) {
      const opts = options || {}
      const isRefresh = opts.isRefresh || false

      if (isRefresh) {
        this.refreshLoader = true
      } else {
        this.initialLoader = true
      }

      axios
        .get('invoices/unmatched_invoices')
        .then(res => {
          this.unmatchedInvoices = res.data.data
          this.errorMessage = null
          this.initialLoader = false
          this.refreshLoader = false
        })
        .catch(error => {
          this.errorMessage = (error && error.response && error.response.data && error.response.data.error) || 'Error fetching Unmatched Invoice'
          this.initialLoader = false
          this.refreshLoader = false
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.invoices-list {
  max-height: 100px;
  overflow-y: auto;
  overflow-x: hidden;
}

.clickable-invoice {
  color: #7367f0;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
}

</style>
